import React from "react";
import { Search } from "lucide-react";

const Hero = () => {
  return (
    <section className="bg-gradient-to-br from-[#F3E8F7] to-[#E9D5F0] px-4 py-28 sm:py-40">
      <div className="mx-auto max-w-[1006px] text-center">
        <h1 className="text-[42px] font-bold leading-[60px] text-[#0F172A] sm:text-[60px]">
          STEAM Minds Blog
        </h1>

        <p className="mx-auto mt-6 max-w-[760px] text-xl  text-[#374151]">
          Discover inspiring STEM education articles, coding tutorials, and
          innovative learning resources for young minds
        </p>

        <div className="mx-auto mt-8 w-full max-w-[672px]">
          <div className="flex h-10 sm:h-16 items-center rounded-full bg-white pl-4 sm:pl-6 pr-2 shadow-[0_20px_50px_rgba(55,65,81,0.16)] ring-1 ring-[#E7DDEE]">
            <input
              type="text"
              placeholder="Search articles..."
              aria-label="Search blog articles"
              className="h-full w-full bg-transparent text-xl sm:text-2xl leading-7 text-[#0F172A] placeholder:text-[#9CA3AF] focus:outline-none"
            />

            <button
              type="button"
              aria-label="Search"
              className="flex h-7 w-7 sm:h-10 sm:w-10 items-center justify-center rounded-full bg-[#923D8C] text-white transition-colors duration-200 hover:bg-[#7E3379]"
            >
              <Search  className="size-4 sm:size-[22px]" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
